import React from 'react'
import MonitoringHeader from 'components/organisms/MonitoringHeader/MonitoringHeader'

import MonitoringList from 'components/molecules/Monitoring/MonitoringList'
import MonitoringCompanyForm from 'components/molecules/Monitoring/MonitoringCompanyForm'
import Button from 'components/molecules/Button'
import { monitoringTemplate } from 'components/molecules/Monitoring/monitoring-task'
import { useMonitoringTasks } from 'components/molecules/Monitoring/hook/use-monitoring'

const MonitoringPage: React.FC = () => {
  const { isOpen, loading, tasks, formData, setIsOpen, handleChange, createTask, deleteTaskById } = useMonitoringTasks()

  return (
    <div className="container page-content d-flex flex-column flex-grow-1">
      <MonitoringHeader />

      <div className="alert alert-info my-3" role="alert">
        Нажмите кнопку «Новая задача», введите ИНН.
        <br />
        Система ОТК раз в неделю будет проверять, что у компании:
        <br />
        - Директор не поменялся
        <br />
        - Банковский счет не заблокирован
        <br />
        - Изменилось количество негативных упоминаний в АТИ
        <br />
        - Изменилась сумма исков по арбитражным делам
        <br />А если что-то изменилось, мы отправим уведомление в Telegram.
      </div>

      <div className="p-2">
        <h5>Список задач мониторинга</h5>
        <Button onClick={() => setIsOpen(true)}>Новая задача</Button>
      </div>

      {tasks.length > 0 ? <MonitoringList tasks={tasks} onDeleteTask={deleteTaskById} /> : <p>Пока нет добавленных задач.</p>}

      <MonitoringCompanyForm
        isVisible={isOpen}
        isLoading={loading}
        template={monitoringTemplate}
        formData={formData}
        onChange={handleChange}
        onSubmit={createTask}
        onClose={() => setIsOpen(false)}
        header="Добавить задачу мониторинга"
      />
    </div>
  )
}

export default MonitoringPage
